<template>
    <div class="iframeCom">
        <div class="iframeBox IsClick" v-if="!config.isClick"></div>
        <iframe class="iframeBox" :src="config.src" :width="config.width+'%'" :height="config.width+'%'" :scrolling="config.scrolling" :style="{opacity:config.opacity}" ></iframe>
    </div>
</template>

<script>
    /**
     @author xcf
     @date 2020/6/29 3:57 下午
     */
    export default {
        name: 'iframeComp',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
             option: {
                type: Object,
                default: ''
            },
            trans: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {}
        },
        computed: {
             config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
        },
        methods: {},
        mounted() {
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    .iframeCom {
        .IsClick{
            z-index: 9999;
        }
        .iframeBox{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
        }
    }
</style>
